<script>

export default {
    name: "occasion-type-filter",
    props: {
        query: {
            type: Object,
            default: () => ({}),
            required: true
        },
        /**
         * An array of tags (bounds).  The list of tags returned from the API will be limited to those in the bounds
         */
        bounds: {
            type: Array,
            default: () => [],
            required: false
        },
        /**
         * Filterable (true/false)
         * If filterable is true, only those tags with a "filterable" value of true in the DB will be returned
         */
        filterable: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            occ_type: null,
            occ_tag: null,
            ocTagOptions: [],
        }
    },
    created() {
        this.occ_type = this.query.occasion_type_id || '';
        this.occ_tag = this.query.occasion_tag_id || '';
    },
    computed: {
        url() {
            let url = '/api/internal/occasion_tags.json?';

            if (this.occ_type) {
                url += 'occasion_type_id=' + this.occ_type
            }

            if (this.bounds.length) {
                url += '&bounds=' + this.bounds
            }

            if (this.filterable) {
                url += `&filterable=${this.filterable}`
            }

            return url;
        }
    },
    watch: {
        url(newVal) {
            if (newVal != null) {
                axios.get(this.url, {
                        headers: {
                            'Accept': 'application/json'
                        }
                    }
                ).then((response) => {
                    this.ocTagOptions = [];

                    if (response.data.data && response.data.data.length > 0) {
                        response.data.data.forEach((item) => {
                            var option = new Object();
                            option.id = item.id;
                            option.name = item.name;
                            this.ocTagOptions.push(option);
                        });
                    } else {
                        this.occ_tag = '';
                    }
                })
            }
        }

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/OccasionTypeFilter.vue